import { Controller, FieldValues, RegisterOptions } from "react-hook-form";

interface Props {
  label?: string;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  options?: { _id: string | number; title: string }[];
  placeholder?: string;
  error?: boolean;
  control?: any;
  name?: string;
  disabled?: boolean;
  rules?:
    | Omit<
        RegisterOptions<FieldValues, string>,
        "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
      >
    | undefined;
}

export const ControlledSelect = ({
  label,
  className,
  inputClassName,
  labelClassName,
  options,
  placeholder,
  error,
  control,
  name,
  rules,
  disabled,
  ...rest
}: Props) => {
  return (
    <div className={`mb-4 ${className}`}>
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <Controller
        control={control}
        name={name as string}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <select
            {...rest}
            disabled={disabled}
            value={value}
            onChange={onChange}
            className={`w-full h-[46px] px-4 bg-sky-lighter border ${
              error ? "border-red-base" : "border-gray-border"
            } ${
              error ? "focus:border-red-base" : "focus:border-focused-border"
            } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
          >
            {placeholder ? (
              <option value="" disabled selected hidden>
                {placeholder}
              </option>
            ) : null}
            {options?.length
              ? options?.map((option) => (
                  <option key={option?._id} value={option?._id}>
                    {option?.title}
                  </option>
                ))
              : null}
          </select>
        )}
      />
    </div>
  );
};
